import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: "formly-field-submit",
  template: `
    <!-- <input type="input" [formControl]="formControl" [formlyAttributes]="field"> -->
    <button
      type="submit"
      class="{{
        field.templateOptions.className
          ? field.templateOptions.className
          : 'btn btn-default'
      }}"
      [disabled]="field.templateOptions.disabled || form.invalid"
    >
      {{ field.templateOptions.buttonLabel }}
    </button>
    <!-- {{ field.templateOptions.disabled}} -->
  `,
})
export class FormlyFieldSubmit extends FieldType<FieldTypeConfig> { }
